import React, { useState, useMemo } from "react";
import "../DashboardUnique.css";
import { exportYojnaSummaryToExcel, exportYojnaSummaryToPDF, toIndianCurrency, toIndianCurrencyDashboardCard } from "../../../MethodMaster/JSXComponentMothod";

const THEMES = ["yojna-glass-0", "yojna-glass-1", "yojna-glass-2", "yojna-glass-3", "yojna-glass-4"];
const SHIMMER_THEMES = ["shimmer-theme-0", "shimmer-theme-1", "shimmer-theme-2", "shimmer-theme-3", "shimmer-theme-4"];

const ShimmerCard = ({ themeIndex = 0 }) => {
  const theme = SHIMMER_THEMES[themeIndex % 5];
  return (
    <div className={`govdash-shimmerCard ${theme}`}>
      <div className="wave"></div>
      <div style={{ width: "48px", height: "48px", borderRadius: "12px", marginBottom: "1rem" }}></div>
      <div style={{ width: "82%", height: "20px", marginBottom: "0.5rem" }}></div>
      <div style={{ width: "62%", height: "34px", marginBottom: "0.5rem" }}></div>
      <div style={{ width: "52%", height: "16px", marginBottom: "0.5rem" }}></div>
      <div style={{ width: "72%", height: "24px" }}></div>
    </div>
  );
};

const NoDataCard = () => (
  <div className="govdash-noDataCard">
    <i className="govdash-icon fas fa-chart-line"></i>
    <div className="no-data-title">No Yojna Found</div>
    <div className="no-data-desc">Try adjusting your search</div>
  </div>
);

export default function YojnaGrid({ overallDashboardCountData, yojnas = [], onSelect, isLoading = false }) {
  const [search, setSearch] = useState("");

  const filteredYojnas = useMemo(() => {
    if (!search.trim()) return yojnas;
    return yojnas.filter((y) => y?.GramYojnaName?.toLowerCase().includes(search.toLowerCase()));
  }, [yojnas, search]);

  const handleExcelExport = () => exportYojnaSummaryToExcel(overallDashboardCountData, filteredYojnas, "Yojna_Summary");
  const handlePDFExport = () => exportYojnaSummaryToPDF(overallDashboardCountData, filteredYojnas, "Yojna_Summary");

  return (
    <>
      <div className="d-flex flex-column flex-md-row justify-content-between gap-3 gap-md-0">
        <h2 className="govdash-sectionTitle">
          Yojna-wise Summary &nbsp;&nbsp;&nbsp;
          <div className="govdash-totalCountBadge">
            {/* <span className="govdash-totalLabel">Total Yojanas :</span> */}
            <span className="govdash-totalNumber">{yojnas?.length}</span>
          </div>
        </h2>

        {/* Search Bar */}
        <div className="d-flex gap-2">
          <div className="d-flex gap-3 align-items-center flex-wrap">
            <div className="govdash-searchWrapper">
              <i className="fas fa-search "></i>
              <input type="text" placeholder="Search Yojna Name..." value={search} onChange={(e) => setSearch(e.target.value)} className="govdash-searchInput" />
              {search && (
                <button onClick={() => setSearch("")} className="govdash-clearSearch">
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>
          <div>
            <button onClick={handleExcelExport} className="govdash-excelBtn mt-4">
              <i className="fas fa-file-excel"></i> Export Excel
            </button>
          </div>
          {/* <div>
          <button onClick={handlePDFExport} className="govdash-pdfBtn mt-4">
            <i className="fas fa-file-pdf"></i> Download PDF
          </button>
          </div> */}
        </div>
      </div>

      <div className="govdash-grid6">
        {isLoading ? (
          Array(20).fill()?.map((_, i) => <ShimmerCard key={i} themeIndex={i} />)
        ) : filteredYojnas.length > 0 ? (
          filteredYojnas.map((y, i) => {
            const theme = THEMES[i % 5];
            return (
              <div key={y.GramYojnaID} className={`govdash-yojnaCard ${theme}`}
              onClick={() => onSelect(y)}
              >
                <i className={`govdash-icon ${y?.IconName || "fas fa-heart"}`}></i>
                <div className="govdash-yojnaName">{y?.GramYojnaName}</div>
                <div className="govdash-labharti">{y?.BeneficialCount?.toLocaleString()}</div>
                {/* <div className="govdash-labharti">{toIndianCurrency(y?.BeneficialCount)}</div> */}
                <div style={{ fontSize: "0.9rem", color: "#64748b", marginBottom: "0.25rem" }}>Labharthi</div>
                {/* {y?.TotalAmount ? <div className="govdash-amount">₹{y?.TotalAmount?.toLocaleString()}</div> : ""} */}
                {/* {y?.TotalAmount ? <div className="govdash-amount">{toIndianCurrency(y?.TotalAmount)}</div> : ""} */}
                {y?.TotalAmount ? <div className="govdash-amount">{toIndianCurrencyDashboardCard(y?.TotalAmount)}</div> : ""}
                <span className="govdash-statusBadge govdash-active">Active</span>
              </div>
            );
          })
        ) : (
          <NoDataCard />
        )}
      </div>
    </>
  );
}
